import { Item } from 'interfaces/models/carts';
import { OutletMenuItem, Promotion } from 'interfaces/models/menu';
import { useEffect } from 'react';

import { isEditingCart } from '../../../helper/cart';

type TypeProps = {
  item: OutletMenuItem | null;
  isOutofStock?: boolean;
  quantity?: number;
};
export function calculateDiscountedPrice(value: number, discountType: any, basicPrice: number) {
  if (discountType === '$') {
    let price = basicPrice - value;
    price < 0 ? (price = basicPrice) : '';
    return price;
  } else if (discountType === '%') {
    const removeprice = (basicPrice * value) / 100;
    return basicPrice - removeprice;
  } else {
    return basicPrice;
  }
}

const DiscountPrice = ({ item, isOutofStock, quantity }: TypeProps) => {
  if (item?.promotions && item?.promotions.length > 0) {
    return (
      <>
        <div className="price">
          ${' '}
          {(
            calculateDiscountedPrice(
              item?.promotions[0].value ?? 0,
              item?.promotions[0].discountType ?? 0,
              item.basicPrice
            ) || 0
          ).toFixed(2)}
        </div>
        {!isOutofStock && quantity === 0 && (
          <div className="price thumbnail-old-pricing">$ {(item?.basicPrice || 0).toFixed(2)}</div>
        )}
      </>
    );
  } else {
    return <div className="price">$ {(item?.basicPrice || 0).toFixed(2)}</div>;
  }
};

export default DiscountPrice;
